
import { Options, Vue } from 'vue-class-component';
import SummaryCard from "../components/summary-card/index.vue";
import HeaderFilterBar from "../components/header-filter-bar/index.vue";
import { PickupDashboardMonitoringCourierSummary } from '@/domain/entities/PickupDashboard';
import { Range } from '@/app/ui/components/date-range-picker/type';
import { PickupDashboardMonitoringCourierData, PickupDashboardMonitoringCourierPickup } from '@/domain/entities/PickupDashboard';
import CourierTable from "../components/courier-table/index.vue";
import { Pagination } from "@/domain/entities/Pagination";
import OverlayPanel from "primevue/overlaypanel";
import absolutePosition from "@/app/infrastructures/misc/common-library/dom/absolutePosition";
import { PickupDashboardController } from "@/app/ui/controllers/PickupDashboardController";
import {
  CourierListRequest,
  CourierSummaryRequest
} from "@/data/payload/api/PickupDashboardRequests";
import { debounce } from "lodash";
import {
  formatDateNormal,
  formatDateNumber,
  parsingErrorResponse,
  whatsapp,
  formatByCountry
} from "@/app/infrastructures/misc/Utils";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ExportApiRequest } from "@/data/payload/api/PickupDashboardApiRequest";
import { ReportController } from "@/app/ui/controllers/ReportController";
import { QueryParamsEntities } from "@/domain/entities/MainApp";
import {
  codePhoneCountry,
  nationalPrefixExist
} from "../../../shipment/booking/booking-utils";
import { DownloadReportRequest } from "@/domain/entities/Kulioner";
import formatPhoneNumber from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";

@Options({
  components: {
    SummaryCard,
    HeaderFilterBar,
    CourierTable,
    OverlayPanel
  }
})
class PickupDashboardMonitoringCourier extends Vue {
  codePhoneCountry = codePhoneCountry;
  nationalPrefixExist = nationalPrefixExist;
  whatsapp = whatsapp;
  formatPhoneNumber = formatPhoneNumber;
  isSummaryOpen = true;
  isLoading = false;
  errorCause = "";
  tooltipSellerCount = 0;

  params = {
    search: "",
    dateRange: new Range(),
    shipmentType: [],
    sortBy: "",
    sortDirection: "",
    pagination: new Pagination(1, 10, 100)
  };

  summaryData: PickupDashboardMonitoringCourierSummary[] = [];
  tableData: PickupDashboardMonitoringCourierData[] = [];

  mounted() {
    this.getCourierList();
    this.getCourierPickupSummary();
  }

  get tooltipStyle() {
    return {
      fontFamily: "Montserrat",
      width: "350px",
      backgroundColor: "#1A1421",
      color: "#FFFFFF",
      fontSize: "12px",
      marginTop: "20px",
      visibility: "hidden",
      textAlign: "center"
    };
  }

  get isFiltering() {
    return !!this.params.search || !!this.params.shipmentType.length || !!this.params.dateRange.end || !!this.params.dateRange.start
  }

  get column(): any {
    return [
      {
        name: "pickupDashboard.column.no",
        style: {
          width: "50px",
          textAlign: "center"
        },
        slotName: "no"
      },
      {
        name: "pickupDashboard.column.courierName",
        sortBy: "courier_name",
        style: {
          width: "215px"
        },
        slotName: "courier_name"
      },
      {
        name: "pickupDashboard.belumDiPickUp",
        sortBy: "crrotw",
        style: {
          width: "188.5px"
        },
        slotName: "crrotw"
      },
      {
        name: "pickupDashboard.belumDisetor",
        sortBy: "crrpic",
        style: {
          width: "188.5px"
        },
        slotName: "crrpic"
      },
      {
        name: "pickupDashboard.belumBkd",
        sortBy: "crrdon",
        style: {
          width: "188.5px"
        },
        slotName: "crrdon"
      },
      {
        name: "Total Pick Up",
        sortBy: "total_pickup",
        style: {
          width: "188.5px"
        },
        slotName: "total_pickup"
      },
      {
        name: "pickupDashboard.column.action",
        style: {
          width: "84px"
        },
        slotName: "action",
        isAction: true
      }
    ];
  }

  fmtQty(val: number | string) {
    return formatByCountry(Number(val || 0), { type: "quantity" });
  }

  getPickupData(status = "", index = 0) {
    const pickupData = this.tableData[index].pickup.find((p) => p.status === status);
    if (status === "ALL") return new PickupDashboardMonitoringCourierPickup({
        isWithinTimeLimit: false,
      quantity:this.tableData[index].pickup.reduce((prev, curr) => prev + curr.quantity, 0),
      seller :this.tableData[index].pickup.reduce((prev, curr) => prev + curr.seller, 0),
      shipment :this.tableData[index].pickup.reduce((prev, curr) => prev + curr.shipment, 0)
    })
    return pickupData;
  }

  get substractHeight() {
    return this.isSummaryOpen ? '477' : '361';
  }

  get offset(){
    return this.params.pagination.limit * (this.params.pagination.page - 1);
  }

  onSearch() {
    this.params.pagination.page = 1;
    this.getCourierList();
    this.getCourierPickupSummary();
  }

  onFilterShipmentType = debounce(() => {
    this.params.pagination.page = 1;
    this.getCourierList();
    this.getCourierPickupSummary();
  }, 400)

  onFilterDate = debounce(() => {
    this.params.pagination.page = 1;
    this.getCourierList();
    this.getCourierPickupSummary();
  }, 400)

  onDownload = debounce(async(date: DownloadReportRequest) => {
    try {
      MainAppController.showLoading();

      await PickupDashboardController.export(
        new ExportApiRequest({
          ...date,
          q: this.params.search,
          shipmentType: Array.isArray(this.params.shipmentType) ? this.params.shipmentType.map((ts: any) => ts.value).join(",") : "",
        })
      );

      await ReportController.onGetListDownloadReport();
      ReportController.setOpenDownloadRequest(true);
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal Download Data !", this.onDownload)
      );
    } finally {
      MainAppController.closeLoading();
    }
  }, 400)

  onSort(sort: {sortBy: string, sortDirection: "ASC" | "DESC"}) {
    this.params.pagination.page = 1;
    this.params.sortBy = sort.sortBy;
    this.params.sortDirection = sort.sortDirection;
    this.getCourierList();
  }

  async toggleTooltip(event: any, sellerCount = 0) {
    this.tooltipSellerCount = sellerCount;
    const refs: any = this.$refs;
    refs["courier-pickup-crrotw"].show(event);
    await this.$nextTick();
    const container = document.getElementById(
      "courier-pickup-crrotw-container"
    );
    if (!container) return;
    absolutePosition(
      container,
      event.currentTarget,
      refs["courier-pickup-crrotw"].visible,
      "center"
    );
  }

  async hideTooltip(event: any) {
    this.tooltipSellerCount = 0;
    const refs: any = this.$refs;
    refs["courier-pickup-crrotw"].hide(event);
  }

  async getCourierPickupSummary() {
    try {
      this.isLoading = true;
      const dateRange = this.params.dateRange;
      const res = await PickupDashboardController.getCourierSummary(
        new CourierSummaryRequest({
          endDate: dateRange.end
            ? formatDateNormal(dateRange.end, "YYYY-MM-DD")
            : "",
          startDate: dateRange.start
            ? formatDateNormal(dateRange.start, "YYYY-MM-DD")
            : "",
          status: "CRROTW,CRRPIC,CRRDON,CRRNFD",
          q: this.params.search,
        })
      )
      this.summaryData = res.data;
    } catch (error) {
      console.log("error: ", error);
    } finally {
      this.isLoading = false;
    }
  }

  async getCourierList() {
    try {
      this.errorCause = "";
      this.isLoading = true;
      const { shipmentType, sortBy, pagination, dateRange, search, sortDirection } = this.params;
      const res = await PickupDashboardController.getCourierList(
        new CourierListRequest({
          page: pagination.page,
          shipmentType: Array.isArray(shipmentType)
            ? shipmentType.map((ts: any) => ts.value).join(",")
            : "",
          sortBy: sortDirection,
          status: "CRROTW,CRRPIC,CRRDON",
          endDate: dateRange.end
            ? formatDateNormal(dateRange.end, "YYYY-MM-DD")
            : "",
          startDate: dateRange.start
            ? formatDateNormal(dateRange.start, "YYYY-MM-DD")
            : "",
          limit: 20,
          orderBy: sortBy,
          q: search
        })
      )

      this.tableData = res.data;
      this.params.pagination = res.pagination;
    } catch (error) {
      const response = (error as { response?: unknown }).response;
      this.errorCause = response ? "server" : "internet";
    } finally {
      this.isLoading = false;
    }
  }

  toggleActionOP(event: any, index = 0) {
    const refs: any = this.$refs;
    const actionOP = refs[`action-${index}`];
    if (actionOP) {
      actionOP.show(event);
    }

  }

  getCourierQueryParam(data: PickupDashboardMonitoringCourierData) {
    return new QueryParamsEntities({
      id: data.courierId,
      courierPhone: data.courierPhone,
      courierName: data.courierName,
      endDate: this.params.dateRange.end
        ? formatDateNormal(this.params.dateRange.end, "YYYY-MM-DD")
        : "",
      startDate: this.params.dateRange.start
        ? formatDateNormal(this.params.dateRange.start, "YYYY-MM-DD")
        : ""
    }).queryString;
  }
}
export default PickupDashboardMonitoringCourier
